import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCarousel from 'vue-carousel';
Vue.config.productionTip = false
Vue.use(VueCarousel);

import 'animate.css/animate.min.css'

import firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBzxK7Gw3kli63S6O6M0r2Xt-vGT0FNZK4",
  authDomain: "usinagem-saraiva.firebaseapp.com",
  databaseURL: "https://usinagem-saraiva.firebaseio.com",
  projectId: "usinagem-saraiva",
  storageBucket: "usinagem-saraiva.appspot.com",
  messagingSenderId: "259253729462"
};
firebase.initializeApp(config);

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
